import React from 'react'
import { AutoComplete, Input } from 'antd'
import { t } from '../../../config/i18n'
import { businessService, IBusinessSearchItem } from '../../../services/BusinessService'
import { debounce } from '../../../lib/utilsCommon'
import styles from './InputSearchBusiness.module.scss'

interface Props {
  width?: number | string
  onSelect: (item: IBusinessSearchItem) => void
}

export const InputSearchBusiness = ({ width, onSelect }: Props) => {
  const [query, setQuery] = React.useState('')
  const [items, setItems] = React.useState<IBusinessSearchItem[]>([])
  const [loading, setLoading] = React.useState(false)
  const options = React.useMemo(() => items.map(renderItem), [items])

  const search = React.useMemo(() => debounce(async (query: string) => {
    const items = await businessService.search(query)
    setItems(items)
    setLoading(false)
  }, 500), [])

  const handleSearch = React.useCallback((query: string) => {
    setLoading(true)
    search(query)
  }, [search])

  const handleSelect = React.useCallback((value: string) => {
    const item = items.find(i => i.id === value)
    item && onSelect(item)
    setQuery('')
    setLoading(false)
    setItems([])
  }, [onSelect, items])

  return (
    <AutoComplete
      className={styles.root}
      style={{ width }}
      dropdownClassName={styles.dropdown}
      // dropdownMatchSelectWidth={width}
      options={options}
      value={query}
      onChange={setQuery}
      onSearch={handleSearch}
      onSelect={handleSelect}
    >
      <Input.Search
        loading={loading}
        placeholder={t.catalog.searchBusiness}
      />
    </AutoComplete>
  )
}

const renderItem = (item: IBusinessSearchItem) => ({
  value: item.id,
  label: (
    <div className={styles.item}>
      {item.general_info.name} <span>{item.id}</span>
    </div>
  ),
})
